import React, { useEffect, useState } from "react";
import moment from "moment";
import memoize from "memoize-one";
import { SvgInfo } from "./SvgInfo";
import elPro from "../../assets/img/elpro.svg";
import { Col, Modal } from "reactstrap";

export const SiniestrosEstados = ({
    historial,
    revision,
    fecha,
    aseguradora,
    siniestro,
    modal,
    marginUp,
    zoho2,
    zohoFormItem,
    setInstrucciones,
    creacionFc,
    hospitalario,
    ...props
}) => {
    const [paso1, setPaso1] = useState({
        paso: true,
        indexs: [],
        fechas: [],
        mensaje: "",
        ultimo: true,
        nm: "Subir Documentos",
    }); //subir documentos
    const [paso2, setPaso2] = useState({
        paso: revision,
        indexs: [],
        fechas: [],
        mensaje: "",
        ultimo: false,
        nm: "Revisión",
    }); //revisión
    const [paso3, setPaso3] = useState({
        paso: false,
        indexs: [],
        fechas: [],
        mensaje: "",
        ultimo: false,
        nm: "Análisis",
    }); //análisis
    const [paso4, setPaso4] = useState({
        paso: false,
        indexs: [],
        fechas: [],
        mensaje: "",
        ultimo: false,
        nm: "Respuesta",
    }); //respuesta
    const [paso5, setPaso5] = useState({
        paso: false,
        indexs: [],
        fechas: [],
        mensaje: "",
        ultimo: false,
        nm: "Acciones Pendientes",
    }); //acciones pendientes menos respuesta
    const [paso6, setPaso6] = useState({
        paso: false,
        indexs: [],
        fechas: [],
        mensaje: "",
        ultimo: false,
        nm: "Acciones Pendientes",
    }); //acciones pendientes solo desde respuesta
    const [mensaje, setMensaje] = useState(setInstrucciones ? "" : "Aún no se ha receptado información"); //mensaje
    const [viewG, setViewG] = useState(true);
    const [viewS, setViewS] = useState(false);
    const [viewM, setViewM] = useState(false);

    useEffect(() => {
        if (historial?.length > 0) {
            setPaso1({
                ...paso1,
                paso: true,
                indexs: [],
                fechas: [creacionFc ? creacionFc : ""],
                mensaje: "",
                ultimo: false,
            });
            analisis(historial);
            respuesta(historial);
            pendientes(historial);
        } else {
            //setPaso1({paso: true, indexs: [], fechas: [], mensaje: "", ultimo: false});
            setPaso2({ ...paso2, paso: false, indexs: [], fechas: [], mensaje: "", ultimo: false });
            setPaso3({ ...paso3, paso: false, indexs: [], fechas: [], mensaje: "", ultimo: false });
            setPaso4({ ...paso4, paso: false, indexs: [], fechas: [], mensaje: "", ultimo: false });
            setPaso5({ ...paso5, paso: false, indexs: [], fechas: [], mensaje: "", ultimo: false });
            setPaso6({ ...paso6, paso: false, indexs: [], fechas: [], mensaje: "", ultimo: false });
        }
    }, [historial]);

    function setPasoAnterior(paso, setPaso, hist, index) {
        let tmp = paso;
        tmp.paso = true;
        tmp.indexs.push(index);
        tmp.fechas.push(hist.fecha);
        setPaso(tmp);
    }

    function setPasoActual(paso, setPaso, index, estado) {
        let tmp = paso;
        tmp.paso = true;
        if (index === historial.length - 1) {
            tmp.fechas.push(fecha);
            tmp.indexs.push(index);
            //buscar estado
            tmp.mensaje = buscarMensaje(estado);
            tmp.ultimo = true;
            setMensaje(tmp.mensaje);
        }
        setPaso(tmp);
    }

    function analisis(historial) {
        historial.forEach((hist, index) => {
            if (
                hist.actualizado.toLowerCase().indexOf("enviado aseguradora") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("enviado a aseguradora") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("solicitado crédito a aseguradora") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("en espera") >= 0
            ) {
                setPasoActual(paso3, setPaso3, index, hist.actualizado);
                if (
                    hist.transition.toLowerCase().indexOf("envio documentos aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("solicitar crédito hospitalario") >= 0 ||
                    hist.transition.toLowerCase().indexOf("escalar") >= 0 ||
                    hist.transition.toLowerCase().indexOf("solicitud aprob. cred. hospt.") >= 0
                ) {
                    setPasoAnterior(paso2, setPaso2, hist, index);
                } else if (
                    hist.transition.toLowerCase().indexOf("envio dctos aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("solicitar aprob. cred. hosp") >= 0 ||
                    hist.transition.toLowerCase().indexOf("envio otra vez dctos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("envio dctos completos") >= 0
                ) {
                    setPasoAnterior(paso5, setPaso5, hist, index);
                } else {
                    console.log("No encontro conciedencia para " + hist.transition);
                }
            }
        });
    }

    function respuesta(historial) {
        historial.forEach((hist, index) => {
            if (
                hist.actualizado.toLowerCase().indexOf("liquidado efi") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("notificado liquidación") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("notificado liquidacion") >= 0 ||
                hist.actualizado.toLowerCase() === "cerrado" ||
                hist.actualizado.toLowerCase().indexOf("crédito hospitalario aprobado") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("liq. nota cobranza efi") >= 0
            ) {
                setPasoActual(paso4, setPaso4, index, hist.actualizado);
                if (
                    hist.transition.toLowerCase().indexOf("liquidacion efi") >= 0 ||
                    hist.transition.toLowerCase().indexOf("envio liquidación por email") >= 0 ||
                    hist.transition.toLowerCase().indexOf("aprobación del crédito hospit.") >= 0 ||
                    hist.transition.toLowerCase().indexOf("nota de cobranza") >= 0 ||
                    hist.transition.toLowerCase().indexOf("liq. nota cobranza efi") >= 0 ||
                    hist.transition.toLowerCase().indexOf("negado") >= 0 ||
                    hist.transition.toLowerCase().indexOf("devolución aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("cerrar por falta de documentac") >= 0 ||
                    hist.transition.toLowerCase().indexOf("cerrar por falta de documentos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("cerrar sin documentos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("solicitar crédito nuevamente") >= 0 ||
                    hist.transition.toLowerCase().indexOf("regreso a gestión trámites ad") >= 0 ||
                    hist.transition.toLowerCase().indexOf("envio otra vez dctos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("envio dctos completos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("escalario a nivel superior") >= 0
                ) {
                    setPasoAnterior(paso3, setPaso3, hist, index);
                } else if (hist.transition.toLowerCase().indexOf("liq. nota de cobranza efi") >= 0) {
                    setPasoAnterior(paso5, setPaso5, hist, index);
                } else {
                    console.log("No encontro conciedencia para " + hist.transition);
                }
            }
        });
    }

    function pendientes(historial) {
        historial.forEach((hist, index) => {
            if (
                hist.actualizado.toLowerCase().indexOf("gestión trámites adicionales") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("gestión ad´l créditos hospitalarios") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("gestion ad´l créditos hospitalarios") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("devolución de aseguradora") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("nota de cobranza pendiente") >= 0 ||
                hist.actualizado.toLowerCase().indexOf("cerrado sin documentación completa") >= 0
            ) {
                if (
                    hist.transition.toLowerCase().indexOf("gestion tramites adicionales") >= 0 ||
                    hist.transition.toLowerCase().indexOf("gestión adicional para crédito") >= 0
                ) {
                    setPasoActual(paso5, setPaso5, index, hist.actualizado);
                    setPasoAnterior(paso2, setPaso2, hist, index);
                } else if (
                    hist.transition.toLowerCase().indexOf("cerrar por falta de documentac") >= 0 ||
                    hist.transition.toLowerCase().indexOf("cerrar por falta de documentos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("cerrar sin documentos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("nota de cobranza") >= 0 ||
                    hist.transition.toLowerCase().indexOf("devolución de aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("devolución aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("devolucion de aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("devolucion aseguradora") >= 0 ||
                    hist.transition.toLowerCase().indexOf("solicitar crédito nuevamente") >= 0 ||
                    hist.transition.toLowerCase().indexOf("regreso a gestión trámites ad") >= 0 ||
                    hist.transition.toLowerCase().indexOf("envio otra vez dctos") >= 0 ||
                    hist.transition.toLowerCase().indexOf("escalar a nivel superior") >= 0
                ) {
                    setPasoActual(paso6, setPaso6, index, hist.actualizado);
                    setPasoAnterior(paso4, setPaso4, hist, index);
                } else {
                    console.log("No encontro conciedencia para " + hist.transition);
                }
            }
        });
    }

    function buscarMensaje(estado) {
        if (estado.toLowerCase() === "abierto") {
            return (
                "Los documentos relacionados a tus siniestro están siendo revisados por nuestro equipo. Si están completos, los remitiremos a " +
                aseguradora +
                " hasta " +
                fechaFormato(fecha) +
                "; si no lo están te lo comunicaremos sobre la marcha para tomar acciones, por favor estar pendiente de nuestros comunicados."
            );
        } else if (estado.toLowerCase() === "crédito hospitalario") {
            return (
                "Los documentos relacionados al crédito hospitalario/ambulatorio están siendo revisados por nuestro equipo. Si están completos, los remitiremos a " +
                aseguradora +
                " hasta " +
                fechaFormato(fecha) +
                "; si no lo están te lo comunicaremos sobre la marcha para tomar acciones, por favor estar pendiente de nuestros comunicados."
            );
        } else if (estado.toLowerCase() === "enviado a aseguradora" || estado.toLowerCase() === "enviado aseguradora") {
            return (
                "Los documentos relacionados a este siniestro han sido enviados a " +
                aseguradora +
                " para su análisis y esperamos tener una respuesta máximo hasta " +
                fechaFormato(fecha) +
                "."
            );
        } else if (estado.toLowerCase() === "solicitado crédito a aseguradora") {
            return (
                "La solicitud para tu crédito hospitalario/ambulatoria han sido enviados a " +
                aseguradora +
                " para su análisis, y esperamos tener una respuesta máximo hasta " +
                fechaFormato(fecha) +
                "."
            );
        } else if (estado.toLowerCase() === "en espera") {
            return "Este ticket ha sido escalado; para mayores detalles por favor contacta a tu ejecutivo de cuenta.";
        } else if (
            estado.toLowerCase() === "gestión trámites adicionales" ||
            estado.toLowerCase() === "gestion tramites adicionales"
        ) {
            return "Los documentos presentados para tu reembolso no están completos para poder ser enviados a la aseguradora todavía. Por favor, debes estar pendiente de nuestras comunicaciones por email, teléfono o WhatsApp ya que probablemente necesitemos de tu intervención para terminar de documentar tu caso.";
        } else if (
            estado.toLowerCase() === "gestión ad´l créditos hospitalarios" ||
            estado.toLowerCase() === "gestion ad´l créditos hospitalarios"
        ) {
            return "Los documentos presentados para tu solicitar tu crédito hospitalario no están completos para poder ser enviados a la aseguradora todavía. Por favor, debes estar pendiente de nuestras comunicaciones por email, teléfono o WhatsApp ya que probablemente necesitemos de tu intervención para terminar de documentar tu caso.";
        } else if (
            estado.toLowerCase() === "devolución de aseguradora" ||
            estado.toLowerCase() === "devolucion de aseguradora"
        ) {
            return (
                aseguradora +
                " nos ha devuelto su siniestro. Para poder continuar con el mismo por favor, debes estar pendiente de nuestras comunicaciones por email, teléfono o WhatsApp ya que probablemente necesitemos de tu intervención."
            );
        } else if (estado.toLowerCase() === "nota de cobranza pendiente") {
            return (
                "Tu siniestro por " +
                siniestro.nmIncapacidad +
                ", sobre el cual tuviste un crédito hospitalario/ambulatorio ha sido liquidado por " +
                aseguradora +
                " y se ha generado una nota de cobranza, que debes pagarla, por favor comunicate con tu ejecutivo de cuenta para mayor información."
            );
        } else if (
            estado.toLowerCase() === "cerrado sin documentación completa" ||
            estado.toLowerCase() === "cerrado sin documentacion completa"
        ) {
            return (
                "No hemos recibido los documentos necesarios completos para poder enviar tu siniestro a la aseguradora, y lamentablemente ya no podremos tenerlo abierto por más tiempo. " +
                "Si tú logras conseguir dichos documentos antes de la fecha de vencimiento de tus facturas para reembolso, remítenoslo nuevamente y con mucho gusto re-abrimos tu caso."
            );
        } else if (
            estado.toLowerCase() === "liquidado efi" ||
            estado.toLowerCase() === "notificado liquidación" ||
            estado.toLowerCase() === "notificado liquidacion"
        ) {
            return (
                "El reembolso de tu siniestro por " +
                siniestro.nmIncapacidad +
                ", ha sido procesado por " +
                aseguradora +
                ". Para mayor información no dudes en contactar a tu ejecutivo de cuenta."
            );
        } else if (estado.toLowerCase() === "cerrado") {
            return (
                "El reembolso de tu siniestro por " +
                siniestro.nmIncapacidad +
                ", fue negado por " +
                aseguradora +
                ". Para mayor información no dudes en contactar a tu ejecutivo de cuenta."
            );
        } else if (
            estado.toLowerCase() === "crédito hospitalario aprobado" ||
            estado.toLowerCase() === "credito hospitalario aprobado"
        ) {
            return (
                "el crédito hospitalario/ambulatorio de tu siniestro por " +
                siniestro.nmIncapacidad +
                ", ha sido aprobado por " +
                aseguradora +
                ". Para mayor información no dudes en contactar a tu ejecutivo de cuenta."
            );
        } else if (estado.toLowerCase() === "liq. nota cobranza efi") {
            return (
                "Tu siniestro por " +
                siniestro.nmIncapacidad +
                " está totalmente liquidado y diligenciado, y tu nota de cobranza también ya está pagada a " +
                aseguradora +
                ". Si necesitas alguna aclaración adicional, no dudes en contactar a tu ejecutivo de cuenta."
            );
        } else {
            return "Aún no se ha receptado información";
        }
    }

    const fechaFormato = memoize((fecha, format = "DD/MMM/YYYY") => {
        return fecha ? moment(fecha).locale("moment/locale/es").format(format) : "";
    });

    function findNombre() {
        if (paso1.ultimo) {
            return paso1.nm;
        }

        if (paso2.ultimo) {
            return paso2.nm;
        }

        if (paso3.ultimo) {
            return paso3.nm;
        }

        if (paso4.ultimo) {
            return paso4.nm;
        }

        if (paso5.ultimo) {
            return paso5.nm;
        }

        if (paso6.ultimo) {
            return paso6.nm;
        }
    }

    const ZohoFormItem = zohoFormItem;

    function onCloseZohoForm() {
        setTimeout(function () {
            try {
                if (viewM) {
                    // para cerrar modal xq estoy dentro d un siniestro
                    setViewM(false);
                } else {
                    setViewG(true);
                    setViewS(false);
                    // muevo step
                    setPaso2({ ...paso2, paso: true });
                }
                setInstrucciones && setInstrucciones(false);
            } catch (e) {
                console.log(e);
            }
        }, 1500);
    }

    return (
        <div className="card bg-primary border-radious-none siniestros-info">
            {viewG && !viewS && (
                <div className="card-body ">
                    <SvgInfo
                        paso1={paso1}
                        paso2={paso2}
                        paso3={paso3}
                        paso4={paso4}
                        paso5={paso5}
                        paso6={paso6}
                        fechaFormato={fechaFormato}
                        setViewG={setViewG}
                        setViewS={setViewS}
                        setViewM={setViewM}
                        modal={modal}
                        setInstrucciones={setInstrucciones}
                        {...props}
                    />

                    {mensaje && (
                        <div className={"siniestros-msg row"}>
                            <div className={"col-auto"}>
                                <img src={elPro} alt="..." className={"asistente"} />
                            </div>
                            <Col className={"text-primary"}>
                                <h5>{findNombre()}</h5>
                                {mensaje}
                            </Col>
                        </div>
                    )}
                </div>
            )}
            {!viewG && viewS && (
                <div className="card-body">
                    <div className={"text-right"}>
                        <button
                            type="button"
                            className="close"
                            title="Cerrar"
                            aria-label="Close"
                            onClick={() => {
                                setViewG(true);
                                setViewS(false);
                                setInstrucciones && setInstrucciones(false);
                            }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <ZohoFormItem
                        zoho2={zoho2}
                        siniestro={siniestro}
                        onClose={onCloseZohoForm}
                        isOpen={viewM}
                        hospitalario={hospitalario}
                    />
                </div>
            )}
            <Modal isOpen={viewM} size="lg" className={"siniestros-info"}>
                <div className="card-body">
                    <div className={"text-right"}>
                        <button
                            type="button"
                            className="close"
                            title="Cerrar"
                            aria-label="Close"
                            onClick={() => {
                                setViewM(false);
                                setInstrucciones && setInstrucciones(false);
                            }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    {viewM && (
                        <ZohoFormItem
                            zoho2={zoho2}
                            siniestro={siniestro}
                            onClose={onCloseZohoForm}
                            isOpen={viewM}
                            hospitalario={hospitalario}
                        />
                    )}
                </div>
            </Modal>
        </div>
    );
};
